









































































import Vue from 'vue'
import { ArticleData } from 'HealthAdvisorBackendApp'
import { makeArticleSchemaJsonLD } from './makeArticleSchemaJsonLD'
import NavbarHeader from '@/components/shared/NavbarHeader/index.vue'
import ArticleBody from '@/components/shared/ArticleBody/index.vue'
import TagSimple from '@/components/shared/TagSimple/index.vue'
import BreadCrumbs, {
  PathItem
} from '@/components/shared/Breadcrumbs/index.vue'
import { apiFetcher } from '@/utils/api/fetcher'
import { formatDateSimple } from '@/utils/date'
import NoPicPlaceholder from '@/static/images/no-pic-placeholder.jpg'
import { routes } from '@/utils/routes'
import ArticleReferences from '@/components/shared/ArticleReferences/index.vue'

export default Vue.extend({
  name: 'Article',
  components: {
    NavbarHeader,
    BreadCrumbs,
    ArticleBody,
    ArticleReferences,
    TagSimple
  },
  async asyncData({ $axios, params, error }) {
    const start = new Date().getTime()
    const fetchedArticles = await apiFetcher<ArticleData>({
      $axios,
      error,
      apiUrl: `/article/${params.article}/`
    })
    const { responseData, head } = fetchedArticles
    const end = new Date().getTime()

    const categoryName =
      (responseData.categories && responseData.categories[0].name) || ''
    const categorySlug =
      (responseData.categories && responseData.categories[0].slug) || ''
    const categoryUrl = routes.articlesCategory.makeUrl(categorySlug)
    const mainImageUrl =
      responseData.image || (responseData.data?.gallery || [])[0]

    // 404 redirection if url has wrong category
    if (params.category !== categorySlug) {
      error({ statusCode: 404, message: 'Page not found' })
    }

    const pageTitle = responseData.post_title || ''
    const pageUrl = routes.article.makeUrl(params.category, params.article)
    const breadcrumbs: PathItem[] = [
      {
        pageName: 'Health A - Z',
        url: routes.articles.makeUrl()
      },
      {
        pageName: categoryName,
        url: categoryUrl
      },
      {
        pageName: pageTitle,
        url: pageUrl
      }
    ]

    const references =
      responseData.data?.reference && Array.isArray(responseData.data.reference)
        ? responseData.data.reference
        : []

    const schemaJsonLD = makeArticleSchemaJsonLD({
      categoryName,
      articleName: pageTitle,
      lastReviewData: responseData.data?.last_review_date || '',
      articleUrl: pageUrl,
      imageUrl: mainImageUrl || NoPicPlaceholder
    })

    return {
      title: pageTitle,
      content: responseData.post_content || '',
      categoryName,
      categoryUrl,
      authorName: responseData.author?.full_name || '',
      publishDate: formatDateSimple(
        responseData.post_date,
        'yyyy-MM-dd HH:mm:ss'
      ),
      mainImageUrl: mainImageUrl || NoPicPlaceholder,
      mainImageAlt: responseData.post_title,
      lastReviewDate: responseData.data?.last_review_date || 'N/A',
      nextReviewDate: responseData.data?.next_update || 'N/A',
      breadcrumbs,
      references: references.map((ref) => ({
        text: ref.text || '',
        url: ref.url || ''
      })),
      head,
      schemaJsonLD,
      perf: end - start
    }
  },
  mounted() {
    console.info('perf', this.$data.perf)
  },
  jsonld() {
    return this.$data.schemaJsonLD || null
  },
  head() {
    return this.$data.head
      ? {
          ...this.$data.head
        }
      : {}
  }
})
